import { QueryHookOptions, useQuery } from '@apollo/client';
import { AccessLevel } from 'redux/authentication/enums';

import { USER_BY_ROLE_QUERY_FOR_USER_LIST_SCREEN } from './queries';
import { User } from './types';

export const useUsersByRoleForUserListScreen = (role: AccessLevel, onlyActive: boolean, options?: QueryHookOptions) =>
  useQuery<{ users: User[] }>(USER_BY_ROLE_QUERY_FOR_USER_LIST_SCREEN, { ...options, variables: { role, onlyActive } });
